import styled from 'styled-components';
import CustomIcon from '../_CustomIcon';

export const StyledIcon = styled(CustomIcon)`
  svg {
    fill: transparent;
  }
`;
